if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.errorMessages = document.querySelector('#error-messages-prescription');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage(false);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const dataObject = this.prunePropertiesAndGetTags(formData);

        config.body = dataObject.FormData;

        // The only magic required to force creation of new line items in case prescription matches.
        // We don't need to handle quantity merge within the matching line item if the user attempts to create
        // another line items with the same sets of prescription
        dataObject.FormData.set('properties[__timestamp]', Date.now());

        const query = this.getQueryTerm(dataObject.TagRight, dataObject.TagLeft);

        const queryProducts = `{
              products(first: 250, query: "${query}") {
                edges {
                  node {
                    id
                    title
                    tags
                    variants(first: 5) {
                      edges {
                        node {
                          id
                          title
                          sku
                          barcode
                        }
                      }
                    }
                  }
                }
              }
            }`;

        // Making our request
        fetch(window.storefront.url, {
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': window.storefront.publicToken,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: queryProducts
          })
        })
          .then((res) => res.json())
          .then(async (res) => {
            const isSupplierDetailsEntered = this.enterSuppliersDetails(res, dataObject, formData);
            if (isSupplierDetailsEntered) {
              this.addToCart(config, formData);
            } else {
              throw new Error(this.errorMessages.dataset.errorPrescriptionUnavailable);
            }
          })
          .catch((errorMsg) => {
            console.log(errorMsg);
            this.handleErrorMessage(errorMsg);
          })
          .finally(() => {
            this.performFinalHandling();
          });
      }

      enterSuppliersDetails(res, dataObject, formData) {
        if (res.data && res.data.products && res.data.products.edges) {
          res.data.products.edges.forEach((element) => {
            if (element.node.variants.edges[0].node.barcode && element.node.variants.edges[0].node.barcode !== '') {
              if (element.node.tags && dataObject.TagRight && element.node.tags.includes(dataObject.TagRight)) {
                formData.set('properties[__external-right-upc]', element.node.variants.edges[0].node.barcode);
              }
              if (element.node.tags && dataObject.TagLeft && element.node.tags.includes(dataObject.TagLeft)) {
                formData.set('properties[__external-left-upc]', element.node.variants.edges[0].node.barcode);
              }
            }
          });

          if (
            res.data.products.edges.length === 0 ||
            (parseInt(formData.get('properties[Right Box]')) > 0 &&
              !formData.get('properties[__external-right-upc]')) ||
            (parseInt(formData.get('properties[Left Box]')) > 0 && !formData.get('properties[__external-left-upc]'))
          ) {
            return false;
          }
          return true;
        }
        return false;
      }

      addToCart(config, formData) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description, 'product-form__error-message-wrapper');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.performFinalHandling();
          });
      }

      performFinalHandling() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(`#product-form-error-message`);
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(`#product-form-error-message .product-form__error-message`);

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getQueryTerm(tagRight, tagLeft) {
        let query = '';

        if (tagRight && tagLeft && tagRight === tagLeft) {
          query = `tag:'${tagRight}'`;
        } else {
          if (tagRight) {
            query = `tag:'${tagRight}'`;
          }
          if (tagLeft && tagLeft) {
            query += ` OR tag:'${tagLeft}'`;
          }
          if (!tagRight && tagLeft) {
            query = `tag:'${tagLeft}'`;
          }
        }

        return query;
      }

      prunePropertiesAndGetTags(formData) {
        const selecteRightValue = parseInt(formData.get('properties[Right Box]'));
        const selectedLeftValue = parseInt(formData.get('properties[Left Box]'));
        let tagRight, tagLeft;
        const sku = this.form['properties[_Health Fund Code]'].dataset.sku;

        if (sku) tagRight = tagLeft = `specs_${sku}`;
        else tagRight = tagLeft = 'specs';

        if (selecteRightValue > 0 && selectedLeftValue > 0) {
          for (const pair of formData.entries()) {
            if (pair[0].startsWith('properties[_Right')) tagRight += `_${pair[1]}`;
            if (pair[0].startsWith('properties[_Left')) tagLeft += `_${pair[1]}`;
          }
          return { FormData: formData, TagLeft: tagLeft, TagRight: tagRight };
        } else if (selecteRightValue === 0) {
          deleteRightPrescriptionProperties();
          tagRight = null;
          for (const pair of formData.entries()) if (pair[0].startsWith('properties[_Right')) formData.delete(pair[0]);
          for (const pair of formData.entries()) if (pair[0].startsWith('properties[_Left')) tagLeft += `_${pair[1]}`;
          return { FormData: formData, TagLeft: tagLeft, TagRight: tagRight };
        } else if (selectedLeftValue === 0) {
          deleteLeftPrescriptionProperties();
          tagLeft = null;
          for (const pair of formData.entries()) if (pair[0].startsWith('properties[_Left')) formData.delete(pair[0]);
          for (const pair of formData.entries()) if (pair[0].startsWith('properties[_Right')) tagRight += `_${pair[1]}`;
          return { FormData: formData, TagLeft: tagLeft, TagRight: tagRight };
        } else {
          tagLeft = null;
          tagRight = null;
          deleteAllPrescriptionProperties();
          return { FormData: formData, TagLeft: tagLeft, TagRight: tagRight };
        }

        function deleteRightPrescriptionProperties() {
          formData.delete('properties[Right Box]');
        }

        function deleteLeftPrescriptionProperties() {
          formData.delete('properties[Left Box]');
        }

        function deleteAllPrescriptionProperties() {
          deleteLeftPrescriptionProperties();
          deleteLeftPrescriptionProperties();
          formData.delete('properties[_Health Fund Code]');
        }
      }
    }
  );
}
